import type { CommonColumns } from './common_columns';
import { commonColumns } from './common_columns';

export type SignateNotifications = CommonColumns & {
  resourceName: string;
  title: string;
  body: string;
  status: string;
  displayKind: string;
  targetPage: string;
  targetUser: string;
  showAdmin: string;
  showUser: string;
  period: string;
  startedAt: string;
  finishedAt: string;
  externalLinkUrl: string;
};

export const signateNotifications: Readonly<SignateNotifications> = {
  ...commonColumns,
  ...{
    resourceName: 'SIGNATEからのお知らせ',
    title: 'タイトル',
    body: '本文',
    status: 'ステータス',
    displayKind: '表示タイプ',
    targetPage: '表示箇所',
    targetUser: '対象',
    showAdmin: '組織管理者に表示',
    showUser: '組織ユーザーに表示',
    period: '掲載期間',
    startedAt: '開始日',
    finishedAt: '終了日',
    externalLinkUrl: '外部URL',
  },
};

export const signateNotificationsStatusName = (
  status: 'draft' | 'unpublished' | 'published' | undefined
): string => {
  switch (status) {
    case 'draft':
      return '下書き';
    case 'unpublished':
      return '非公開';
    case 'published':
      return '公開';
    default:
      return '';
  }
};

export const signateNotificationsStatusClass = (
  status: 'draft' | 'unpublished' | 'published' | undefined
) => {
  switch (status) {
    case 'draft':
      return 'text-warning';
    case 'published':
      return 'text-success';
    case 'unpublished':
      return '';
    default:
      return '';
  }
};

export const signateNotificationsDisplayKindName = (
  status: 'none' | 'important' | undefined
): string => {
  switch (status) {
    case 'none':
      return 'なし';
    case 'important':
      return '重要';
    default:
      return '';
  }
};

export const signateNotificationsDisplayKindClass = (
  status: 'none' | 'important' | undefined
) => {
  if (status === 'important') {
    return 'text-danger';
  } else {
    return '';
  }
};

export const signateNotificationsTargetPageName = (
  status: 'home' | 'sign_in' | undefined
): string => {
  switch (status) {
    case 'home':
      return 'Home画面';
    case 'sign_in':
      return 'サインイン画面';
    default:
      return '';
  }
};
